import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { CreateBlankPoRequest } from 'src/types/manage_suppliers/bankPo';
import axiosInstance from 'src/utils/axios';

const createBlankPo = async (request: CreateBlankPoRequest) => {
  const response = await axiosInstance.post<number>(api.createBlankPo, request);
  return response.data;
};

const useCreateBlankPoMutation = () =>
  useMutation({
    mutationKey: queryKeys.createBlankPo.createBlankPo(),
    mutationFn: createBlankPo,
  });

export default useCreateBlankPoMutation;
